export default __webpack_public_path__ + "static/img9-8f52d8f33e8ebdc1eb546ab3c498a139.webp";